module.exports = {
      id: "whatsappcolorround-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-fa9bd75c1e834befd19aa957a85e34e1.svg#whatsappcolorround",
      toString: function () {
        return this.url;
      }
    }